/*
 * @Author: Teemo Ding
 * @Date: 2021-12-02 14:31:01
 * @LastEditTime: 2022-01-29 11:10:59
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/SalesChannel/index.tsx
 */
import React, { Fragment } from 'react';
import { Form } from 'antd';
import { get } from 'lodash';
import { SectionWrapper } from 'src/components/Layouts';
import { ChannelType } from 'src/types/common/SalesChannel';
import { Input } from '@/src/components/Antd';
import { getSalesChannels } from 'src/constrains/GlobalProvider/slice';
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { useSelector } from 'react-redux';
const SalesChannel = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { availableLanguage, hideLanguage, disable } = props;
  const salesChannels = useSelector(getSalesChannels());
  const noMiniProgramSalesChannel = salesChannels.filter(
    (o) =>
      o.channelType !== ChannelType.MiniProgram &&
      o.channelType !== ChannelType.MiniProgramNativeMobile,
  );
  // const salesChannelOptions = (salesChannels || []).map((item) => ({
  //   label: item.name,
  //   value: item.uuid,
  // }));
  return (
    <SectionWrapper
      title={getI18n('general.sider.salesChannel')}
      containerClassName={css.section}
      titleClassName={css.sectionTitle}>
      <Form.Item
        name='salesChannel'
        className={css.formItem}
        rules={[
          {
            required: true,
            message: replaceI18nVariables(
              getI18n('general.fieldisrequired'),
              getI18n('general.sider.salesChannel'),
            ),
          },
        ]}
        label={`${getI18n('general.sider.salesChannel')}*`}
        labelCol={{ span: 24 }}>
        <SelectObjectAsValue
          objectAsValue
          size='large'
          disabled={disable}
          getPopupContainer={(trigger) => trigger}
          valueKey='uuid'
          labelKey='name'
          options={noMiniProgramSalesChannel}
        />
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(p, c) => {
          const cC = get(c, 'salesChannel');
          const pC = get(p, 'salesChannel');
          return cC !== pC;
        }}>
        {({ getFieldValue }: any) => (
          <Fragment>
            <Form.Item
              name='salesRepresentative'
              label={getI18n(
                'allOrders.createneworder.components_saleschannel_salesrepresentative',
              )}
              className={css.formItem}
              labelCol={{ span: 24 }}>
              <Input
                disabled={disable || !getFieldValue('salesChannel')}
                size='large'
              />
            </Form.Item>
            {!hideLanguage && (
              <Form.Item
                name='languageCode'
                label={getI18n(
                  'allOrders.createneworder.components_saleschannel_orderlanguage',
                )}
                className={css.formItem}
                rules={[
                  {
                    required: true,
                    message: getI18n(
                      'allOrders.createneworder.components_saleschannel_orderlanguage_required',
                    ),
                  },
                ]}
                labelCol={{ span: 24 }}>
                <SelectObjectAsValue
                  objectAsValue
                  size='large'
                  disabled={disable || !getFieldValue('salesChannel')}
                  getPopupContainer={(trigger) => trigger}
                  valueKey='uuid'
                  labelKey='name'
                  options={availableLanguage}
                />
                {/* <Input disabled={!getFieldValue('salesChannel')} size='large' /> */}
              </Form.Item>
            )}
          </Fragment>
        )}
      </Form.Item>
    </SectionWrapper>
  );
};

export default SalesChannel;
